import type { HTMLAttributes, Ref } from 'react'
import React from 'react'
import classNames from 'classnames'

import './styles.css'

export type SidebarShellProps = HTMLAttributes<HTMLDivElement> & {
  ref?: Ref<HTMLDivElement>
}

export function SidebarShell({
  className,
  children,
  ref,
  ...props
}: SidebarShellProps) {
  return (
    <div
      ref={ref}
      className={classNames(
        'sidebar-shell width-full height-full flexbox flexbox-column position-relative',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
